import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from "../../assets/white_logo.svg";

const WrapperLogoGroup = styled(`div`)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  cursor: "pointer",
  fontWeight: 600,
  width: "fit-content",
}));
const StyledSVG = styled(Logo)(({ color }) => ({
  width: "40px",
  height: "40px",
  marginRight: "18px",
  "& path": {
    fill: color
  }
}));;

type LogoFull = {
  color?: string;
}

const LogoFull = ( {color="#ffffff"}: LogoFull) => {
  const { t } = useTranslation()
  return (
    <>
      <WrapperLogoGroup>
        <StyledSVG color={color} />
        <Typography variant="h6" color={color}>{t("appbar.label")}</Typography>
      </WrapperLogoGroup>
    </>
  );
};

export default LogoFull;
